const TAG_BESTSELLERS = 'byo-bestseller';
const TEXT_CONTENT_BESTSELLERS = 'BESTSELLER';

const STORAGE_KEY_BESTSELLERS = 'vsly-variants-bestseller';
const REFRESH_TIME_BESTSELLERS = 60 * 60 * 1000; //1 hour

let variantIds = new Set();

init();

async function init() {
  await loadProductsFromStorage();
  addBadges();
}

function getContrastTextColor(hexColor) {
  hexColor = hexColor.replace(/^#/, '');

  let r = parseInt(hexColor.substr(0, 2), 16);
  let g = parseInt(hexColor.substr(2, 2), 16);
  let b = parseInt(hexColor.substr(4, 2), 16);

  let luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? '#000000' : '#FFFFFF';
}

function hexToRgb(hex) {
  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  const num = parseInt(hex, 16);

  return {
    r: (num >> 16) & 255,
    g: (num >> 8) & 255,
    b: num & 255,
  };
}

function hexToRgbArray(hex) {
  const { r, g, b } = hexToRgb(hex);
  return [r, g, b];
}

function addBadges() {
  loomi_api
    .when(() => document.querySelector('.samples-block[data-badge-id]'))
    .then(() => {
      document.querySelectorAll('.samples-block[data-badge-id]').forEach((el) => {
        const id = el.getAttribute('data-badge-id');
        const color_bg = el.getAttribute('data-border-color') || '#000000';
        const color_txt = getContrastTextColor(color_bg);

        el.style.setProperty('--color-bg', hexToRgbArray(color_bg));
        el.style.setProperty('--color-txt', hexToRgbArray(color_txt));

        if (variantIds.has(id)) {
          const title = el.querySelector('.sample-block__title');

          if (title && !el.querySelector('.bestseller-badge')) {
            const span = document.createElement('span');

            span.textContent = TEXT_CONTENT_BESTSELLERS;
            span.style.background = color_bg;
            span.style.color = color_txt;
            span.className = 'bestseller-badge';
            title.insertAdjacentElement('afterend', span);
            title.classList.add('has-badge');
          }
        }
      });
    });
}

async function loadProductsFromStorage() {
  const saved = localStorage.getItem(STORAGE_KEY_BESTSELLERS);
  try {
    if (saved) {
      const { timestamp, variantIds: ids } = JSON.parse(saved);
      if (timestamp && Date.now() - parseInt(timestamp) < REFRESH_TIME_BESTSELLERS) {
        variantIds = new Set(ids || []);
        return;
      }
    }
  } catch (err) {
    console.log('Parse Error', err);
  }

  localStorage.removeItem(STORAGE_KEY_BESTSELLERS);
  await updateLocalStorage();
}

async function updateLocalStorage() {
  variantIds = await getRecommendedVariantIds();
  localStorage.setItem(
    STORAGE_KEY_BESTSELLERS,
    JSON.stringify({
      timestamp: Date.now().toString(),
      variantIds: Array.from(variantIds),
    }),
  );
}

async function getRecommendedVariantIds() {
  try {
    const allocatorResp = await loomi_api.allocatorQuery({
      queries: [{ name: 'tags', oneOf: { handlesByTag: TAG_BESTSELLERS } }],
    });

    const handles = allocatorResp?.results?.tags?.handles;
    if (!handles?.length) return new Set();

    const encoded = btoa(unescape(encodeURIComponent(JSON.stringify({ handles }))));
    const resp = await fetch(
      `https://live.visually-io.com/api/recommendations/web/public/v2/recommend?byHandle=${encoded}&al=FULTONANDROARK`,
    );

    if (!resp.ok) return new Set();

    const data = await resp.json();
    const ids = new Set();

    data?.products?.forEach((product) => {
      product.variants?.forEach((variant) => {
        if (variant.variant_id) {
          ids.add(variant.variant_id.toString());
        }
      });
    });

    return ids;
  } catch (error) {
    console.error('Error fetching variant IDs:', error);
    return new Set();
  }
}
